import React from "react";
import '../ladingpageclient/landingclient.css';

const LandingPageClient = () => {
  return (
    <div className="container py-5 text-center">
      <h2 className="fw-bold mb-3">
        Trusted by <span style={{ color: "#ED1C24" }}>great brands</span>
      </h2>
      <p className="text-muted mb-5">
        We have worked with some of the most prestigious brands worldwide.
      </p>

      <div className="clients-slider">
        <div className="clients-track">
          {/* First Row of Logos (repeated twice for loop) */}
          {[
            "/assets/img/clients/accenture.svg",
            "/assets/img/clients/Capgemini.svg",
            "/assets/img/clients/Expedia.svg",
            "/assets/img/clients/Legero.svg",
            "/assets/img/clients/AnytimeFitness.svg",
            "/assets/img/clients/BSIBusinessPark.svg",
            "/assets/img/clients/Gaurcity.svg",
            "/assets/img/clients/KailashHealthcare.svg",
            "/assets/img/clients/PremiumVilla.svg",
            "/assets/img/clients/Samsung.svg",
            "/assets/img/clients/Tsuyo.svg",
            "/assets/img/clients/TVSMotor.svg",
          ].map((logo, i) => (
            <div key={i} className="client-logo">
              <img src={logo} alt={`Client ${i}`} className="img-fluid" />
            </div>
          ))}

          {/* Repeat same logos for seamless infinite scroll */}
          {[
            "/assets/img/clients/accenture.svg",
            "/assets/img/clients/Capgemini.svg",
            "/assets/img/clients/Expedia.svg",
            "/assets/img/clients/Legero.svg",
            "/assets/img/clients/AnytimeFitness.svg",
            "/assets/img/clients/BSIBusinessPark.svg",
            "/assets/img/clients/Gaurcity.svg",
            "/assets/img/clients/KailashHealthcare.svg",
            "/assets/img/clients/PremiumVilla.svg",
            "/assets/img/clients/Samsung.svg",
            "/assets/img/clients/Tsuyo.svg",
            "/assets/img/clients/TVSMotor.svg",
          ].map((logo, i) => (
            <div key={`clone-${i}`} className="client-logo">
              <img src={logo} alt={`Client clone ${i}`} className="img-fluid" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPageClient;
